import React, {useState, useEffect} from "react";

export default function ParkaPrimoInnenjackeBack({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 402"
      enableBackground="new 0 0 500 402"
    >
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.616"
        strokeMiterlimit="10"
        x1="-528.45"
        y1="271.958"
        x2="-527.633"
        y2="272.48"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.616"
        strokeMiterlimit="10"
        x1="-532.383"
        y1="281.601"
        x2="-533.204"
        y2="281.087"
      />
      <g>
        <g>
          <path
            fill={lightContrast}
            onClick={() => handleClick("base")}
            onMouseEnter={() => setLightContrastActive(true)}
            onMouseLeave={() => setLightContrastActive(false)}
            style={
              lightContrastActive && !preview
                ? {fill: adjust(lightContrast, 55)}
                : {fill: lightContrast}
            }
            d="M250.447,392.665c-10.032,0-19.883-0.33-29.277-0.98c-1.023-0.069-2.054-0.143-3.078-0.217
       c-47.898-3.518-70.464-21.24-72.879-23.249c-2.501-2.087-2.501-8.999-2.501-11.601c0-0.668,0.238-3.576,0.526-7.023
       c0.289-3.483,0.649-7.885,0.985-12.481l0.033-0.47c0.995-13.764,1.208-22.087,0.65-25.438c-1.347-8.088,3.113-50.672,4.398-57.104
       c1.027-5.13,0.86-17.296,0.741-22.287l-0.09-3.73l-1.788,3.274c-2.378,4.355-7.665,11.722-11.525,17.101l-0.457,0.636
       c-1.437,1.997-2.57,3.574-3.19,4.509c-1.854,2.776-4.308,9.707-5.931,14.293c-0.67,1.892-1.302,3.679-1.58,4.24
       c-0.962,1.925-9.693,18.931-10.972,20.631c-1.278,1.709-6.857,12.047-7.49,13.22l-0.034,0.065l-0.064,0.177
       c-0.816,2.269-2.873,7.818-4.323,10.354c-1.697,2.979-4.166,13.042-4.441,14.18l-0.014,0.027c-0.294,0.688-1.892,3.942-3.371,5.05
       c-0.974,0.73-4.283,2.29-8.854,4.173l-0.726,0.299l1.4,9.226c-0.122,0.4-1.495,4.186-11.083,7.385
       c-2.487,0.829-4.942,1.25-7.296,1.25c-7.451,0-11.645-4.193-11.686-4.235c-0.962-0.963-1.642-6.433-1.66-13.31v-0.115
       l-0.027-0.113c-0.425-1.79-1.04-3.51-1.634-5.174l-0.05-0.138c-0.598-1.666-1.188-3.313-1.607-5.003
       c-0.828-3.359-1.063-7.103-0.741-11.779c0.149-2.161,0.474-4.369,0.76-6.317c0.271-1.854,0.577-3.953,0.731-5.959
       c0.168-2.12,0.096-4.293,0.026-6.396c-0.07-1.988-0.147-4.163-0.004-6.276c0.119-1.652,0.319-3.372,0.595-5.104l0.089-0.551
       c0.778-4.659,2.009-9.172,3.198-13.536c0.389-1.421,0.776-2.857,1.16-4.311l0.095-0.358l-0.003-0.007
       c0.845-3.261,1.441-5.922,1.875-8.361l0.106-0.603c1.002-5.687,2.039-11.566,2.691-17.462c0.458-4.141,6.656-31.758,10.978-40.828
       c4.335-9.106,18.377-48.104,18.508-48.475l0.092-0.2c3.532-7.64,21.313-46.015,24.524-51.236
       c3.398-5.521,11.084-16.524,11.409-16.99l0.271-0.388l-0.128-0.455c-0.874-3.114-0.753-3.94-0.72-4.074
       c0.281-1.117,1.461-2.206,2.472-2.851c0.504-0.275,3.3-1.707,6.852-1.707h1.396l0.262-0.188c0.679-0.488,6.745-4.815,10.809-6.442
       c0.973-0.384,2.86-1.18,5.282-2.201l1.31-0.552c8.237-3.478,22.024-9.299,25.021-9.986l0.058-0.013l0.056-0.02
       c0.122-0.044,12.356-4.413,16.248-5.708c3.197-1.069,9.491-2.239,11.443-2.564l0.682-0.113l0.135-0.677
       c0.157-0.788,0.426-2.671,0.621-4.047l0.026-0.183c0.143-1.023,0.264-1.885,0.308-2.102c1.325-6.319,3.477-14.258,8.38-19.568
       c3.163-3.424,6.57-5.881,10.127-7.303c5.927-2.374,12.397-4.64,19.564-5.147c1.26-0.089,2.546-0.134,3.822-0.134
       c5.739,0,11.609,0.919,16.976,2.659c5.397,1.758,11.575,4.236,16.466,9.28c6.901,7.125,8.915,17.251,9.975,26.216l0.07,0.595
       l0.175,0.068l-0.138,0.331l1.226,0.218c2.805,0.5,7.949,1.486,10.896,2.47c3.885,1.294,16.129,5.665,16.25,5.709l0.056,0.02
       l0.058,0.013c3.022,0.693,16.79,6.51,25.015,9.986l1.434,0.604c2.363,0.997,4.204,1.772,5.165,2.152
       c3.962,1.587,9.7,5.644,10.811,6.44l0.261,0.188h1.39c3.791,0,6.74,1.644,6.864,1.714c0.945,0.597,2.177,1.712,2.459,2.845
       c0.035,0.138,0.16,0.963-0.716,4.072l-0.128,0.456l0.271,0.388c0.079,0.113,7.968,11.398,11.403,16.989
       c3.1,5.037,19.508,40.386,24.463,51.1l0.156,0.337l0.076,0.215c2.378,6.587,14.442,39.872,18.436,48.259
       c4.301,9.027,10.509,36.674,10.973,40.829c0.87,7.83,2.641,15.544,4.353,23.003c1.046,4.549,2.231,9.705,3.146,14.83
       c0.44,2.439,0.843,5.01,1.229,7.856l-0.002,0.013l0.021,0.156c1.352,10.063,2.026,20.55,2.621,29.804l0.014,0.158
       c0.242,3.815,0.519,8.14-0.413,12.082c-0.371,1.569-1.069,3.005-1.744,4.394c-0.835,1.71-1.586,3.249-1.94,5.066l-0.019,0.094
       v0.096c-0.013,6.876-0.693,12.351-1.655,13.313c-0.048,0.048-4.26,4.243-11.696,4.243c-2.35,0-4.802-0.421-7.288-1.25
       c-9.557-3.188-10.953-6.964-11.086-7.407l1.401-9.203l-0.727-0.299c-3.523-1.448-7.701-3.305-8.856-4.172
       c-1.3-0.975-2.751-3.683-3.404-5.13l-0.003-0.023c-0.254-1.064-2.721-11.13-4.42-14.104c-1.714-2.998-4.248-10.152-4.354-10.455
       l-0.026-0.072l-0.036-0.068c-0.062-0.113-6.146-11.417-7.488-13.217c-1.314-1.747-10.265-19.199-10.975-20.635
       c-0.278-0.562-0.905-2.325-1.579-4.238c-1.645-4.633-4.101-11.549-5.932-14.297c-0.673-1.005-1.929-2.754-3.5-4.938l-0.115-0.16
       c-3.873-5.393-9.178-12.778-11.562-17.146l-1.791-3.28l-0.087,3.736c-0.145,6.224-0.239,17.394,0.742,22.287
       c1.288,6.427,5.753,48.999,4.401,57.104c-1,5.985,0.732,27.024,1.663,38.327c0.3,3.621,0.533,6.433,0.533,7.085
       c0,2.602,0,9.513-2.508,11.601c-6.382,5.319-14.264,8.954-20.418,11.526c-15.317,6.412-33.011,10.241-54.094,11.705
       C273.124,392.257,261.605,392.665,250.447,392.665z"
          />
          <path
            fill={darkContrast}
            onClick={() => handleClick("contrast")}
            onMouseEnter={() => setDarkContrastActive(true)}
            onMouseLeave={() => setDarkContrastActive(false)}
            style={
              darkContrastActive && !preview
                ? {fill: adjust(darkContrast, 55)}
                : {fill: darkContrast}
            }
            d="M449.288,341.551c-0.062,4.536-0.506,11.136-1.572,12.205c-2.383,2.383-9.361,6.055-18.735,2.933
       c-9.179-3.06-10.72-6.622-10.91-7.186l1.236-8.122C422.786,342.511,437.805,346.858,449.288,341.551"
          />
          <path
            fill={darkContrast}
            onClick={() => handleClick("contrast")}
            onMouseEnter={() => setDarkContrastActive(true)}
            onMouseLeave={() => setDarkContrastActive(false)}
            style={
              darkContrastActive && !preview
                ? {fill: adjust(darkContrast, 55)}
                : {fill: darkContrast}
            }
            d="M453.003,330.914c-0.374,1.571-1.08,3.019-1.765,4.42c-0.731,1.497-1.484,3.042-1.868,4.787
       c-12.284,6.142-29.94-0.014-30.35-0.159c-0.286-0.114-7.585-3.077-9.237-4.314c-1.511-1.132-3.096-4.536-3.302-4.99
       c-0.234-0.96-2.721-11.157-4.456-14.195c-1.312-2.294-3.148-7.155-3.954-9.352c4.817,1.259,10.933,2.527,17.422,2.527
       c3.734,0,7.588-0.418,11.387-1.497c10.048-2.854,20.566-7.049,24.252-16.424c1.104,9.022,1.696,18.132,2.267,27.026l0.009,0.141
       C453.655,322.684,453.933,326.995,453.003,330.914"
          />
          <path
            fill="#C8C8C8"
            d="M431.3,202.823c-1.804,2.316-15.092,18.426-41.225,27.271c-13.283,3.986-19.149,4.425-32.067,3.774
       c-1.321-2.108-2.289-3.866-2.598-4.895c-0.334-1.11-0.761-6.318-1.127-13.614c0.717,0.069,1.472,0.1,2.255,0.1
       c11.061,0,27.506-6.647,32.604-8.833c16.639-5.807,30.856-20.35,34.093-23.833c3.146,8.312,6.19,16.071,7.845,19.549
       C431.155,202.497,431.226,202.655,431.3,202.823"
          />
          <path
            fill="#C8C8C8"
            d="M359.898,336.51c-1.871,1.712-11.196,9.267-32.229,11.562c-5.989,0.651-12.541,1.118-20.625,1.47
       c-6.388,0.277-13.208,0.454-20.843,0.533c-6.398,0.067-12.909,0.031-19.205-0.005c-1.633-0.009-3.271-0.017-4.909-0.021
       l-5.681-0.028c-6.044-0.03-12.297-0.061-18.456-0.053c-3.761,0.005-7.42-0.005-10.872-0.021
       c-6.635-0.035-12.615-0.111-18.285-0.233c-6.759-0.141-12.36-0.327-17.622-0.586c-4.267-0.213-9.321-0.498-14.428-1.057
       c-20.915-2.281-30.284-9.766-32.235-11.532c0.74-10.222,1.326-21.279,0.643-25.374c-0.03-0.177-0.053-0.375-0.079-0.586
       c3.041,2.612,12.165,8.88,31.537,10.994c5.139,0.559,10.215,0.85,14.5,1.06c5.274,0.261,10.884,0.446,17.655,0.59
       c5.681,0.12,11.664,0.194,18.303,0.229c3.461,0.023,7.12,0.028,10.884,0.023c6.146-0.005,12.403,0.025,18.448,0.053l5.681,0.025
       c1.633,0.009,3.271,0.018,4.909,0.028c3.69,0.016,7.455,0.039,11.227,0.039c2.669,0,5.341-0.014,7.997-0.039
       c7.652-0.081,14.481-0.256,20.887-0.534c8.11-0.352,14.689-0.819,20.699-1.475c19.372-2.114,28.496-8.382,31.538-10.994
       c-0.027,0.21-0.048,0.409-0.08,0.586C358.576,315.257,359.162,326.299,359.898,336.51"
          />
          <path
            fill="#C8C8C8"
            d="M354.187,229.218c-0.005,0.092-0.008,0.243-0.017,0.441c-3.531,0.519-7.133,0.932-10.518,1.298
       c-9.595,1.035-19.52,1.818-30.35,2.391c-31.447,1.669-65.182,1.859-106.165,0.59c-12.02-0.374-23.922-1.048-35.36-2.012
       c-7.472-0.625-13.68-1.264-19.54-2.009c-0.664-0.083-1.329-0.171-1.994-0.263c-0.009-0.199-0.014-0.344-0.018-0.437
       c0.635-2.377,1.339-13.763,1.688-27.351c0.576,0.08,1.148,0.159,1.726,0.233c5.786,0.745,11.913,1.383,19.284,2.013
       c11.29,0.965,23.024,1.638,34.881,2.011c17.229,0.543,33.409,0.811,48.697,0.811c20.056,0,38.578-0.467,55.918-1.401
       c10.686-0.572,20.477-1.361,29.944-2.394c3.258-0.362,6.727-0.761,10.139-1.268C352.849,215.46,353.553,226.845,354.187,229.218"
          />
          <path
            fill={darkContrast}
            onClick={() => handleClick("contrast")}
            onMouseEnter={() => setDarkContrastActive(true)}
            onMouseLeave={() => setDarkContrastActive(false)}
            style={
              darkContrastActive && !preview
                ? {fill: adjust(darkContrast, 55)}
                : {fill: darkContrast}
            }
            d="M422.741,181.485c-2.051,2.259-16.73,17.934-34.052,23.979c-5.46,2.338-23.87,9.779-34.466,8.626
       c-0.911-19.083-1.362-50.865,1.197-62.721c2.426-11.229,11.127-35.194,16.322-49.516c2.88-7.939,3.796-10.497,3.932-11.233
       c0.246-0.683,0.876-2.426,1.462-4.323c2.077,2.986,7.977,11.526,10.827,16.155c3.429,5.573,24.021,50.15,24.611,51.427
       C412.831,154.593,417.832,168.475,422.741,181.485"
          />
          <path
            fill={darkContrast}
            onClick={() => handleClick("contrast")}
            onMouseEnter={() => setDarkContrastActive(true)}
            onMouseLeave={() => setDarkContrastActive(false)}
            style={
              darkContrastActive && !preview
                ? {fill: adjust(darkContrast, 55)}
                : {fill: darkContrast}
            }
            d="M150.189,214.09c-10.598,1.153-29.006-6.287-34.506-8.643c-17.287-6.027-31.961-21.702-34.012-23.962
       c4.909-13.01,9.911-26.892,10.165-27.605c0.59-1.276,21.183-45.853,24.613-51.426c2.85-4.628,8.749-13.17,10.822-16.156
       c0.59,1.899,1.221,3.642,1.467,4.323c0.136,0.736,1.052,3.294,3.932,11.233c5.196,14.322,13.896,38.287,16.318,49.516
       C151.549,163.227,151.1,195.007,150.189,214.09"
          />
          <path
            fill="#C8C8C8"
            d="M150.128,215.358c-0.365,7.295-0.794,12.504-1.129,13.614c-0.307,1.03-1.275,2.787-2.597,4.895
       c-12.918,0.653-18.783,0.213-32.05-3.763c-26.149-8.855-39.437-24.966-41.242-27.282c0.07-0.166,0.144-0.326,0.221-0.48
       c1.654-3.477,4.698-11.235,7.846-19.547c3.235,3.481,17.447,18.025,34.052,23.815c5.133,2.202,21.579,8.85,32.648,8.85
       C148.657,215.46,149.409,215.429,150.128,215.358"
          />
          <path
            fill={darkContrast}
            onClick={() => handleClick("contrast")}
            onMouseEnter={() => setDarkContrastActive(true)}
            onMouseLeave={() => setDarkContrastActive(false)}
            style={
              darkContrastActive && !preview
                ? {fill: adjust(darkContrast, 55)}
                : {fill: darkContrast}
            }
            d="M106.34,307.111c-0.805,2.197-2.642,7.058-3.954,9.353c-1.74,3.038-4.226,13.243-4.455,14.195
       c-0.493,1.101-1.987,3.999-3.304,4.989c-1.651,1.237-8.951,4.201-9.237,4.314c-0.409,0.146-18.078,6.306-30.362,0.155
       c-0.441-1.77-1.044-3.47-1.634-5.112c-0.581-1.611-1.179-3.276-1.597-4.98c-0.824-3.334-1.057-7.054-0.735-11.699
       c0.141-2.095,0.453-4.236,0.757-6.306c0.286-1.958,0.581-3.979,0.736-5.969c0.166-2.158,0.092-4.364,0.017-6.495
       c-0.066-2.034-0.137-4.139,0.005-6.177c0.057-0.854,0.14-1.704,0.237-2.549c3.158,7.727,11.448,13.543,24.715,17.313
       c3.804,1.078,7.657,1.496,11.39,1.496C95.407,309.638,101.523,308.371,106.34,307.111"
          />
          <path
            fill={darkContrast}
            onClick={() => handleClick("contrast")}
            onMouseEnter={() => setDarkContrastActive(true)}
            onMouseLeave={() => setDarkContrastActive(false)}
            style={
              darkContrastActive && !preview
                ? {fill: adjust(darkContrast, 55)}
                : {fill: darkContrast}
            }
            d="M86.341,349.499c-0.199,0.59-1.76,4.139-10.91,7.19c-9.376,3.121-16.354-0.556-18.735-2.933
       c-1.066-1.07-1.515-7.67-1.571-12.206c11.481,5.306,26.501,0.96,29.979-0.171L86.341,349.499z"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M352.708,228.534c-3.227,0.451-6.433,0.811-9.199,1.11c-9.603,1.035-19.509,1.816-30.278,2.384
       c-17.926,0.953-36.396,1.415-56.462,1.415c-15.425,0-31.647-0.269-49.591-0.826c-12.073-0.375-23.947-1.051-35.29-2.008
       c-7.438-0.623-13.63-1.259-19.485-2.003c-0.232-0.029-0.464-0.058-0.698-0.089"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M153.191,203.375c0.091,0.012,0.184,0.024,0.275,0.036c5.787,0.744,11.933,1.384,19.343,2.017
       c11.245,0.961,23.003,1.64,34.95,2.017c17.122,0.538,33.521,0.812,48.74,0.812c20.155,0,38.469-0.46,55.988-1.402
       c10.613-0.568,20.431-1.354,30.017-2.401c2.813-0.312,5.786-0.655,8.716-1.063"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M358.533,335.948c-2.527,2.125-11.753,8.71-31.008,10.81c-5.949,0.648-12.475,1.112-20.538,1.465
       c-6.418,0.278-13.22,0.453-20.799,0.531c-2.412,0.024-4.989,0.037-7.876,0.037c-3.876,0-7.824-0.022-11.308-0.042
       c-1.634-0.009-3.273-0.018-4.913-0.022l-5.677-0.027c-5.017-0.025-10.702-0.054-16.235-0.054l-4.14,0.003
       c-3.087,0-6.091-0.009-8.954-0.023c-6.71-0.037-12.685-0.112-18.263-0.234c-6.792-0.141-12.379-0.327-17.585-0.583
       c-4.509-0.224-9.37-0.506-14.35-1.051c-19.18-2.091-28.462-8.661-31.013-10.784"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M146.7,313.465c4.581,3.103,13.785,7.679,29.767,9.423c5.156,0.561,10.263,0.854,14.578,1.067
       c5.196,0.256,10.817,0.444,17.692,0.591c5.689,0.119,11.682,0.194,18.324,0.229c2.691,0.018,5.505,0.024,8.394,0.024l3.771-0.001
       c5.132,0,10.348,0.022,15.395,0.045l7.454,0.033l6.71,0.036c3.113,0.015,6.27,0.031,9.432,0.031c2.669,0,5.364-0.014,8.01-0.04
       c7.614-0.079,14.459-0.253,20.931-0.535c8.173-0.353,14.778-0.825,20.784-1.481c15.987-1.745,25.191-6.322,29.77-9.424"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M449.407,288.659c-2.407,9.849-13.081,14.125-23.226,17.011c-3.328,0.943-6.796,1.401-10.601,1.401
       c-5.083,0-10.711-0.828-17.189-2.534"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M429.757,202.633c-2.915,3.531-16.002,18.046-40.083,26.204c-9.991,2.994-15.707,3.956-23.512,3.956
       c-2.078,0-4.381-0.065-7.396-0.21"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M355.68,216.768c0.276,0.008,0.563,0.013,0.858,0.013c11.338,0,28.133-6.805,33.082-8.922
       c15.013-5.254,27.866-17.238,33.124-22.636"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M375.809,80.769c0.053,0.814-1.005,4.751-2.531,8.916l-0.154,0.27v0.327c-0.209,0.802-1.922,5.528-3.582,10.105l-0.214,0.594
       c-5.226,14.395-13.959,38.452-16.421,49.845c-2.048,9.489-2.036,31.812-1.892,42.744"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M293.448,44.558c-0.603-0.192-1.216-0.379-1.842-0.563c-1.008-0.3-2.025-0.568-2.981-0.817l-0.28-0.074
       c-0.653-0.17-1.303-0.34-1.947-0.522c-1.519-0.43-3.129-0.593-4.551-0.736c-0.498-0.051-0.995-0.103-1.478-0.163
       c-7.964-0.993-16.075-1.569-24.111-1.711c-1.31-0.022-2.642-0.033-3.958-0.033c-6.71,0-13.503,0.3-20.194,0.893
       c-2.242,0.199-4.489,0.482-6.662,0.755l-2.118,0.267c-4.411,0.554-9.201,1.958-12.238,2.958"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M217.184,25.295c2.996-3.249,8.604-8.304,11.952-9.64c5.808-2.326,12.139-4.548,19.091-5.043c1.226-0.087,2.476-0.131,3.717-0.131
       c5.572,0,11.272,0.894,16.484,2.589c5.211,1.692,13.228,6.101,17.884,10.904"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M153.331,197.451c1.612-0.824,5.043-2.85,7.712-6.293c5.841-7.541,4.343-28.277-4.459-61.635
       c-6.326-23.983-14.427-46.863-16.723-53.209"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M363.831,75.822c-2.021,5.38-10.328,27.882-17.081,52.011c-9.689,34.619-11.578,56.072-5.617,63.766
       c2.786,3.595,7.548,5.383,9.951,6.092"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M153.405,192.901c0.134-11.061,0.11-32.758-1.901-42.074c-2.463-11.394-11.196-35.452-16.412-49.826l-0.243-0.67
       c-1.63-4.492-3.312-9.133-3.558-10.023v-0.198l-0.122-0.329c-1.543-4.196-2.977-9.949-2.923-10.771"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M145.645,232.583c-3.015,0.146-5.319,0.211-7.401,0.211c-7.8,0-13.511-0.96-23.49-3.949
       c-24.096-8.166-37.185-22.681-40.101-26.212"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M81.667,185.224c5.258,5.399,18.107,17.38,33.084,22.618c4.955,2.122,21.764,8.939,33.126,8.939c0.291,0,0.576-0.005,0.855-0.013"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M106.022,304.537c-6.487,1.705-12.119,2.533-17.199,2.533c-3.802,0-7.267-0.457-10.593-1.401
       c-13.542-3.846-21.506-9.795-23.676-17.683"
          />
          <path
            fill="none"
            stroke={stitching}
            onClick={() => handleClick("stitching")}
            onMouseEnter={() => setStitchingActive(true)}
            onMouseLeave={() => setStitchingActive(false)}
            style={
              stitchingActive && !preview
                ? {stroke: adjust(stitching, 55)}
                : {stroke: stitching}
            }
            strokeWidth="0.616"
            strokeMiterlimit="10"
            strokeDasharray="1.848,1.848"
            d="
       M361.289,354.594c-5.281,4.086-21.116,12.378-26.314,14.552c-14.401,6.027-31.158,9.634-51.23,11.029
       c-11.381,0.79-22.686,1.191-33.602,1.191c-9.782,0-19.426-0.323-28.66-0.958l-0.186-0.013c-0.953-0.066-1.909-0.131-2.86-0.201
       c-40.622-2.982-71.065-21.986-75.975-25.6"
          />
          <path
            fill="#010101"
            d="M454.655,318.801l-0.012-0.137c-0.632-9.826-1.29-19.913-2.628-29.873c0.003-0.021,0.009-0.043,0.02-0.068
       l-0.025-0.006c-0.362-2.672-0.77-5.343-1.249-7.994c-0.893-4.997-2.04-10.023-3.156-14.877c-1.71-7.446-3.473-15.142-4.334-22.891
       c-0.467-4.176-6.713-32.018-11.063-41.147c-4.34-9.115-18.33-47.984-18.473-48.377l-0.016-0.047
       c-0.866-1.87-21.192-45.891-24.693-51.58c-3.208-5.221-10.251-15.345-11.435-17.039c0.543-1.928,0.93-3.771,0.723-4.584
       c-0.494-1.987-2.831-3.404-2.937-3.473c-0.133-0.075-3.272-1.844-7.357-1.844h-1.067c-1.079-0.775-6.942-4.923-11.026-6.559
       c-1.142-0.452-3.537-1.467-6.576-2.747c-8.811-3.723-22.117-9.336-25.181-10.039c-0.739-0.265-12.455-4.445-16.269-5.715
       c-3.193-1.067-8.802-2.108-11.038-2.507l0.053-0.127c-0.186-0.075-0.377-0.143-0.568-0.218
       c-1.094-9.253-3.228-19.546-10.25-26.795c-5.047-5.206-11.361-7.739-16.874-9.535c-6.735-2.183-14.065-3.075-21.177-2.571
       c-7.287,0.516-13.857,2.81-19.865,5.216c-3.708,1.482-7.233,4.027-10.49,7.553c-5.066,5.487-7.271,13.593-8.625,20.046
       c-0.049,0.233-0.148,0.933-0.319,2.161c-0.186,1.311-0.478,3.379-0.638,4.174c-1.822,0.304-8.275,1.492-11.595,2.602
       c-3.819,1.271-15.53,5.451-16.269,5.715c-3.064,0.702-16.37,6.316-25.186,10.039c-3.038,1.28-5.432,2.295-6.576,2.747
       c-4.084,1.636-9.943,5.783-11.021,6.559h-1.073c-4.08,0-7.218,1.768-7.367,1.849c-0.095,0.064-2.427,1.481-2.927,3.468
       c-0.201,0.813,0.187,2.657,0.728,4.584c-1.184,1.693-8.228,11.818-11.441,17.039c-3.499,5.689-23.827,49.71-24.692,51.58
       l-0.016,0.047c-0.139,0.393-14.128,39.262-18.467,48.377c-4.35,9.13-10.607,36.972-11.069,41.147
       c-0.643,5.816-1.678,11.706-2.682,17.4l-0.106,0.601c-0.505,2.841-1.175,5.655-1.897,8.433l-0.122,0.044
       c0,0.009,0.022,0.068,0.07,0.169c-0.383,1.451-0.77,2.884-1.159,4.303c-1.206,4.425-2.438,8.96-3.219,13.634l-0.207,0.047
       c0.031,0.171,0.08,0.34,0.117,0.511c-0.271,1.71-0.478,3.441-0.605,5.194c-0.143,2.103-0.074,4.239,0,6.31
       c0.069,2.098,0.143,4.265-0.022,6.353c-0.149,1.949-0.44,3.952-0.723,5.89c-0.307,2.087-0.62,4.25-0.769,6.395
       c-0.329,4.781-0.085,8.62,0.769,12.089c0.437,1.764,1.048,3.457,1.637,5.098c0.601,1.684,1.228,3.421,1.652,5.206
       c0.006,2.193,0.118,12.179,1.945,14.006c0.233,0.238,4.647,4.536,12.401,4.536c2.263,0,4.807-0.366,7.612-1.302
       c10.793-3.6,11.727-8.03,11.764-8.216l0.016-0.102l-1.308-8.615c1.69-0.697,7.5-3.118,9.073-4.297
       c1.875-1.403,3.649-5.361,3.717-5.525l0.038-0.111c0.027-0.112,2.645-10.952,4.34-13.927c1.715-3.001,4.185-9.927,4.434-10.617
       c0.415-0.77,6.172-11.441,7.409-13.093c1.402-1.864,10.501-19.652,11.069-20.789c0.292-0.59,0.851-2.161,1.626-4.35
       c1.609-4.546,4.047-11.419,5.822-14.075c0.653-0.984,1.901-2.716,3.478-4.908c3.846-5.36,9.301-12.944,11.739-17.41
       c0.127,5.305,0.27,17.112-0.722,22.068c-1.291,6.465-5.764,49.301-4.404,57.465c0.675,4.052,0.059,15.317-0.691,25.611
       l-0.031,0.031l0.028,0.028c-0.336,4.594-0.697,8.991-0.984,12.471c-0.323,3.866-0.53,6.426-0.53,7.106
       c0,4.647,0.323,10.251,2.861,12.37c2.44,2.029,25.199,19.934,73.447,23.477c1.026,0.075,2.057,0.149,3.081,0.218
       c9.509,0.658,19.307,0.982,29.347,0.982c11.174,0,22.636-0.403,34.306-1.216c21.183-1.472,38.98-5.321,54.41-11.781
       c6.226-2.602,14.197-6.284,20.672-11.68c2.545-2.118,2.868-7.723,2.868-12.37c0-0.68-0.211-3.24-0.531-7.106
       c-0.929-11.277-2.66-32.268-1.678-38.142c1.361-8.164-3.112-51-4.408-57.465c-0.995-4.955-0.846-16.762-0.723-22.068
       c2.438,4.467,7.894,12.051,11.744,17.41c1.578,2.192,2.821,3.924,3.479,4.908c1.77,2.656,4.207,9.528,5.82,14.075
       c0.77,2.189,1.334,3.76,1.626,4.35c0.563,1.137,9.667,18.925,11.069,20.789c1.232,1.652,6.995,12.322,7.41,13.093
       c0.244,0.691,2.713,7.617,4.43,10.617c1.699,2.974,4.312,13.815,4.34,13.927l0.037,0.111c0.074,0.164,1.847,4.121,3.718,5.525
       c1.572,1.179,7.382,3.6,9.077,4.297l-1.312,8.615l0.022,0.102c0.031,0.186,0.971,4.616,11.764,8.216
       c2.805,0.936,5.348,1.302,7.605,1.302c7.761,0,12.169-4.298,12.403-4.536c1.833-1.833,1.944-11.856,1.949-14.018
       c0.329-1.689,1.052-3.171,1.817-4.737c0.713-1.466,1.455-2.974,1.86-4.685C455.186,327.102,454.903,322.693,454.655,318.801
        M378.08,87.658c0.185,0.267,0.377,0.548,0.583,0.846c0.1,0.143,0.207,0.298,0.313,0.45c0.404,0.579,0.835,1.212,1.286,1.876
       c0.155,0.217,0.308,0.44,0.462,0.67c0.122,0.18,0.251,0.366,0.372,0.551c0.261,0.372,0.515,0.75,0.77,1.132
       c0.133,0.192,0.261,0.382,0.393,0.58c0.527,0.769,1.052,1.555,1.572,2.331c0.261,0.393,0.52,0.781,0.776,1.163
       c0.509,0.77,1.008,1.519,1.476,2.241c0.35,0.542,0.685,1.063,1.005,1.557c0.099,0.165,0.206,0.323,0.307,0.483
       c0.196,0.319,0.387,0.621,0.568,0.914c3.425,5.577,24.017,50.15,24.613,51.43c0.255,0.713,5.252,14.597,10.166,27.604
       c-2.056,2.263-16.731,17.937-34.057,23.982c-5.454,2.337-23.864,9.778-34.466,8.625c-0.908-19.083-1.358-50.861,1.201-62.722
       c2.427-11.228,11.127-35.194,16.321-49.513c2.88-7.941,3.793-10.5,3.932-11.233c0.244-0.686,0.876-2.428,1.459-4.323
       C377.394,86.67,377.713,87.132,378.08,87.658 M354.189,229.218c-0.006,0.09-0.01,0.245-0.021,0.441
       c-3.526,0.521-7.134,0.934-10.517,1.296c-9.593,1.035-19.52,1.822-30.348,2.396c-31.45,1.668-65.183,1.854-106.165,0.589
       c-12.021-0.377-23.923-1.051-35.359-2.012c-7.472-0.627-13.681-1.265-19.54-2.009c-0.669-0.085-1.333-0.17-1.996-0.266
       c-0.012-0.196-0.012-0.345-0.016-0.435c0.632-2.378,1.338-13.762,1.683-27.349c0.579,0.075,1.153,0.155,1.726,0.23
       c5.785,0.749,11.915,1.386,19.286,2.012c11.292,0.967,23.025,1.641,34.881,2.013c17.23,0.542,33.408,0.812,48.695,0.812
       c20.056,0,38.582-0.467,55.918-1.402c10.687-0.573,20.482-1.36,29.946-2.394c3.255-0.363,6.729-0.76,10.139-1.271
       C352.85,215.462,353.551,226.843,354.189,229.218 M366.548,76.116h1.472c3.739,0,6.709,1.658,6.725,1.669
       c0.016,0.009,1.987,1.209,2.357,2.697c0.27,1.089-1.37,6.363-2.623,9.763l-0.032,0.058v0.112
       c-0.08,0.553-1.842,5.402-3.876,11.016c-5.206,14.352-13.928,38.365-16.371,49.673c-1.758,8.164-2.114,27.056-1.838,44.275
       c-1.662-0.45-6.617-2.024-9.199-5.354c-12.869-16.608,20.89-107.487,23.323-113.962L366.548,76.116z M209.979,43.202
       c0.139-0.967,0.266-1.876,0.307-2.083c1.318-6.294,3.458-14.187,8.318-19.45c3.134-3.399,6.512-5.832,10.04-7.239
       c5.916-2.369,12.375-4.632,19.487-5.137c6.957-0.494,14.117,0.378,20.704,2.517c5.37,1.748,11.505,4.202,16.365,9.216
       c6.612,6.82,8.742,16.572,9.835,25.452c-1.169-0.409-2.421-0.813-3.802-1.216c-0.977-0.292-1.976-0.552-2.943-0.807
       c-0.753-0.196-1.507-0.394-2.251-0.599c-1.386-0.394-2.878-0.548-4.323-0.691c-0.509-0.054-1.02-0.107-1.51-0.171
       c-7.912-0.988-15.976-1.556-23.97-1.699c-7.993-0.137-16.066,0.149-24.013,0.855c-2.384,0.214-4.784,0.521-7.1,0.807l-1.631,0.208
       c-5.509,0.694-11.605,2.735-14.033,3.6C209.58,46.017,209.744,44.891,209.979,43.202 M148.952,69.466
       c1.147-0.462,3.547-1.476,6.591-2.762c8.281-3.489,22.132-9.336,25.017-9.98l0.074-0.021c0.122-0.047,12.365-4.415,16.274-5.721
       c3.916-1.306,11.712-2.602,11.803-2.619c0.117-0.021,0.211-0.037,0.292-0.1c1.178-0.441,8.318-3.064,14.647-3.857l1.632-0.207
       c2.306-0.292,4.69-0.599,7.053-0.807c7.898-0.7,15.934-0.988,23.88-0.849c7.952,0.143,15.967,0.712,23.838,1.695
       c0.499,0.058,1.013,0.111,1.535,0.164c1.392,0.143,2.831,0.286,4.11,0.654c0.755,0.211,1.514,0.408,2.279,0.605
       c0.956,0.255,1.944,0.514,2.906,0.796c1.578,0.468,3.005,0.93,4.312,1.402l0.049,0.425l0.467,0.08
       c0.081,0.016,7.926,1.328,11.791,2.619c3.91,1.306,16.158,5.674,16.281,5.721l0.074,0.021c2.88,0.643,16.737,6.49,25.012,9.98
       c3.042,1.286,5.448,2.3,6.591,2.762c3.315,1.318,7.988,4.468,9.974,5.854c-1.768,4.647-36.908,97.846-23.257,115.471
       c3.053,3.935,8.859,5.549,10.214,5.884c0.021,1.328,0.052,2.645,0.079,3.941c-3.442,0.511-6.948,0.919-10.246,1.281
       c-9.444,1.035-19.211,1.822-29.871,2.39c-30.524,1.646-64.714,1.838-104.512,0.595c-11.834-0.377-23.546-1.051-34.812-2.013
       c-7.351-0.626-13.465-1.264-19.232-2.003c-0.616-0.084-1.237-0.169-1.855-0.255c0.038-1.316,0.065-2.649,0.087-3.994
       c0.961-0.43,4.976-2.395,7.971-6.266c13.321-17.188-18.584-105.937-21.723-114.536C139.507,74.938,145.138,70.991,148.952,69.466
        M127.311,80.482c0.367-1.488,2.338-2.688,2.342-2.692c0.032-0.016,2.995-1.674,6.735-1.674h0.664
       c2.49,6.847,34.8,96.897,21.958,113.469c-2.397,3.09-5.567,4.923-6.959,5.634c0.27-17.177-0.084-35.979-1.844-44.116
       c-2.443-11.308-11.159-35.321-16.369-49.673c-2.034-5.614-3.793-10.463-3.867-10.973v-0.106l-0.042-0.106
       C128.682,86.846,127.035,81.572,127.311,80.482 M91.837,153.88c0.59-1.28,21.182-45.853,24.613-51.43
       c2.847-4.626,8.747-13.167,10.82-16.151c0.589,1.895,1.222,3.637,1.466,4.323c0.139,0.733,1.057,3.292,3.935,11.233
       c5.194,14.319,13.894,38.285,16.317,49.513c2.561,11.86,2.114,43.639,1.201,62.722c-10.597,1.153-29.006-6.288-34.503-8.647
       c-17.289-6.023-31.964-21.697-34.016-23.96C86.579,168.477,91.583,154.593,91.837,153.88 M86.339,349.5
       c-0.195,0.59-1.757,4.137-10.909,7.187c-9.375,3.123-16.354-0.553-18.734-2.933c-1.066-1.067-1.513-7.669-1.572-12.206
       c11.484,5.306,26.504,0.962,29.978-0.169L86.339,349.5z M105.992,308.051c-0.096,0.26-0.202,0.536-0.313,0.828
       c-0.075,0.196-0.149,0.398-0.23,0.599c-0.079,0.214-0.164,0.426-0.248,0.649c-0.081,0.207-0.165,0.413-0.25,0.632
       c-0.202,0.504-0.41,1.02-0.621,1.529l-0.128,0.319c-0.117,0.266-0.229,0.531-0.341,0.791c-0.18,0.409-0.355,0.807-0.53,1.19
       c-0.329,0.712-0.648,1.36-0.946,1.875c-1.736,3.039-4.228,13.242-4.455,14.198c-0.494,1.098-1.987,3.993-3.305,4.988
       c-1.646,1.237-8.95,4.201-9.236,4.312c-0.409,0.144-18.075,6.306-30.36,0.155c-0.441-1.768-1.047-3.469-1.637-5.11
       c-0.579-1.614-1.178-3.277-1.599-4.982c-0.824-3.33-1.057-7.054-0.733-11.695c0.14-2.099,0.453-4.239,0.755-6.304
       c0.286-1.961,0.584-3.985,0.737-5.976c0.165-2.155,0.092-4.36,0.017-6.49c-0.021-0.595-0.037-1.2-0.053-1.807
       c-0.021-1.02-0.032-2.04-0.006-3.059c0.016-0.441,0.032-0.877,0.064-1.312c0.059-0.855,0.143-1.705,0.239-2.549
       c3.156,7.727,11.446,13.543,24.715,17.31c3.802,1.079,7.654,1.498,11.387,1.498c6.49,0,12.61-1.271,17.422-2.528
       c-0.074,0.207-0.161,0.435-0.251,0.685C106.056,307.875,106.023,307.96,105.992,308.051 M136.294,248.515
       c-1.585,2.204-2.838,3.947-3.507,4.945c-1.859,2.788-4.323,9.752-5.954,14.356c-0.7,1.982-1.312,3.686-1.571,4.208
       c-0.697,1.402-5.503,10.771-8.557,16.422c-0.01,0.006-0.016,0.006-0.027,0.006v0.058c-0.059,0.229-0.181,0.435-0.308,0.633
       c-0.096,0.149-0.176,0.297-0.26,0.452c-0.065,0.117-0.139,0.233-0.223,0.34h0.005c-0.748,1.354-1.311,2.342-1.572,2.688
       c-1.249,1.656-6.496,11.356-7.41,13.044c-11.748,3.155-20.985,3.559-29.043,1.275c-14.181-4.031-22.472-10.384-24.66-18.888
       c0.765-4.727,2.018-9.332,3.24-13.82c0.244-0.893,0.487-1.801,0.732-2.709c0-0.09-0.006-0.186,0.01-0.27
       c0.031-0.165,0.118-0.304,0.174-0.457c0-0.012,0.028-0.117,0.033-0.127c0.015-0.059,0.037-0.118,0.053-0.177
       c0.047-0.132,0.09-0.254,0.133-0.386c0.021-0.069,0.042-0.14,0.064-0.214c0,0,0.027-0.132,0.031-0.132
       c0.016-0.075,0.037-0.139,0.059-0.198c-0.01-0.016-0.016-0.036-0.027-0.053c0.713-2.735,1.365-5.524,1.864-8.339l0.106-0.605
       c1.008-5.711,2.045-11.617,2.697-17.475c0.431-3.898,5.939-28.549,10.173-38.969c3.038,3.717,16.466,18.721,41.423,27.167
       c10.288,3.091,16.178,4.073,24.225,4.073c2.247,0,4.658-0.079,7.383-0.206C142.816,239.438,138.996,244.754,136.294,248.515
        M148.999,228.974c-0.308,1.03-1.275,2.783-2.598,4.892c-12.917,0.654-18.782,0.213-32.05-3.76
       c-26.147-8.855-39.437-24.97-41.243-27.285c0.075-0.165,0.149-0.325,0.224-0.479c1.651-3.478,4.694-11.233,7.845-19.55
       c3.234,3.483,17.447,18.026,34.05,23.815c5.137,2.204,21.58,8.855,32.649,8.855c0.782,0,1.529-0.031,2.252-0.106
       C149.764,222.652,149.334,227.864,148.999,228.974 M360.929,349.612c0.304,3.702,0.521,6.374,0.521,7.006
       c0,2.326,0,9.397-2.418,11.409c-6.347,5.29-14.212,8.918-20.348,11.488c-15.307,6.406-32.973,10.225-54.016,11.691
       c-22.085,1.53-43.438,1.61-63.477,0.233c-1.025-0.074-2.056-0.143-3.081-0.217c-47.856-3.516-70.328-21.193-72.734-23.195
       c-2.418-2.012-2.418-9.082-2.418-11.409c0-0.632,0.218-3.304,0.526-7.006c0.261-3.23,0.596-7.262,0.908-11.505
       c3.134,2.607,12.679,9.077,32.22,11.207c5.137,0.558,10.214,0.85,14.501,1.063c5.274,0.26,10.882,0.44,17.655,0.589
       c5.677,0.117,11.663,0.191,18.302,0.229c3.453,0.021,7.113,0.032,10.883,0.021c6.14-0.006,12.403,0.028,18.447,0.053l5.684,0.028
       c1.63,0.009,3.265,0.015,4.907,0.025c3.692,0.016,7.447,0.037,11.224,0.037c2.671,0,5.343-0.01,7.999-0.037
       c7.652-0.079,14.485-0.255,20.888-0.531c8.112-0.356,14.687-0.822,20.699-1.476c19.594-2.14,29.117-8.642,32.209-11.233
       C360.329,342.341,360.658,346.378,360.929,349.612 M327.668,348.073c-5.99,0.653-12.539,1.119-20.623,1.47
       c-6.391,0.276-13.211,0.452-20.842,0.531c-6.4,0.069-12.913,0.031-19.207-0.006c-1.636-0.006-3.271-0.016-4.913-0.022
       l-5.678-0.025c-6.045-0.032-12.297-0.059-18.458-0.053c-3.76,0.005-7.419,0-10.872-0.021c-6.635-0.032-12.616-0.112-18.283-0.234
       c-6.761-0.139-12.359-0.325-17.623-0.583c-4.265-0.214-9.321-0.5-14.426-1.057c-20.916-2.279-30.286-9.768-32.235-11.532
       c0.737-10.224,1.321-21.278,0.642-25.372c-0.031-0.176-0.052-0.378-0.08-0.589c3.044,2.613,12.163,8.88,31.539,10.994
       c5.137,0.563,10.214,0.849,14.501,1.063c5.274,0.26,10.882,0.446,17.655,0.589c5.677,0.122,11.663,0.198,18.302,0.229
       c3.458,0.022,7.118,0.027,10.883,0.022c6.146,0,12.403,0.025,18.447,0.053l5.684,0.025c1.63,0.012,3.265,0.022,4.907,0.027
       c3.692,0.022,7.453,0.044,11.23,0.044c2.665,0,5.338-0.017,7.993-0.044c7.652-0.08,14.485-0.254,20.888-0.531
       c8.112-0.35,14.687-0.818,20.699-1.476c19.372-2.114,28.496-8.381,31.539-10.994c-0.025,0.211-0.053,0.414-0.079,0.589
       c-0.686,4.089-0.102,15.133,0.636,25.341C358.028,338.225,348.702,345.776,327.668,348.073 M359.458,308.762
       c-1.179,1.194-9.832,9.178-31.79,11.574c-5.99,0.647-12.539,1.116-20.623,1.465c-6.391,0.283-13.211,0.457-20.842,0.537
       c-6.4,0.065-12.913,0.032-19.207-0.006c-1.636-0.009-3.271-0.015-4.913-0.021l-5.678-0.027
       c-6.045-0.031-12.297-0.064-18.458-0.053c-3.755,0.006-7.414-0.005-10.872-0.021c-6.635-0.037-12.616-0.112-18.283-0.233
       c-6.761-0.143-12.359-0.329-17.623-0.584c-4.265-0.212-9.321-0.5-14.426-1.057c-21.963-2.396-30.615-10.384-31.788-11.574
       c-0.416-11.649,3.319-48.249,4.594-54.612c1.094-5.45,0.855-18.447,0.728-23.232c0.595,0.084,1.2,0.164,1.801,0.245
       c5.874,0.743,12.104,1.38,19.592,2.008c11.463,0.967,23.382,1.641,35.423,2.012c17.804,0.553,34.238,0.829,49.714,0.829
       c20.184,0,38.742-0.472,56.562-1.42c10.851-0.573,20.799-1.358,30.418-2.394c3.326-0.36,6.863-0.765,10.347-1.269
       c-0.133,4.785-0.366,17.772,0.722,23.222C356.133,260.513,359.867,297.113,359.458,308.762 M357.53,233.095
       c-0.155-0.254-0.304-0.499-0.441-0.738c-0.214-0.362-0.41-0.701-0.584-1.026c-0.298-0.542-0.548-1.029-0.744-1.455
       c-0.154-0.344-0.27-0.647-0.35-0.902c-0.335-1.11-0.759-6.322-1.126-13.618c0.716,0.075,1.472,0.106,2.251,0.106
       c11.063,0,27.508-6.651,32.608-8.834c0.399-0.137,0.79-0.281,1.184-0.43c0.899-0.335,1.785-0.701,2.667-1.083
       c0.18-0.075,0.355-0.154,0.536-0.233c0.648-0.286,1.286-0.59,1.923-0.903c0.18-0.085,0.36-0.176,0.541-0.266
       c0.038-0.016,0.075-0.031,0.112-0.059c0.303-0.143,0.606-0.297,0.902-0.456c2.168-1.126,4.261-2.358,6.257-3.644
       c0.304-0.191,0.601-0.388,0.893-0.579c0.978-0.647,1.934-1.305,2.862-1.971c0.267-0.191,0.526-0.377,0.782-0.568
       c0.281-0.202,0.558-0.408,0.834-0.616c1.088-0.807,2.135-1.625,3.139-2.433c0.349-0.282,0.694-0.564,1.035-0.844
       c0.377-0.308,0.744-0.616,1.104-0.925c0.261-0.217,0.515-0.435,0.765-0.647c0.58-0.5,1.138-0.995,1.673-1.472
       c0.273-0.245,0.531-0.478,0.787-0.707c0.031-0.031,0.07-0.064,0.106-0.1c0.218-0.196,0.431-0.393,0.639-0.584
       c0.121-0.111,0.238-0.223,0.36-0.335c0.117-0.111,0.233-0.217,0.345-0.329c1.147-1.082,2.136-2.055,2.932-2.867
       c0.18-0.186,0.357-0.362,0.515-0.526c0.085-0.091,0.165-0.171,0.244-0.251c0.304-0.319,0.569-0.595,0.792-0.834
       c0.053-0.059,0.106-0.117,0.159-0.17c0.1,0.26,0.195,0.515,0.297,0.77c0.393,1.035,0.787,2.061,1.169,3.07
       c0.191,0.498,0.382,0.998,0.573,1.492c0.288,0.743,0.568,1.47,0.846,2.182c0.186,0.474,0.366,0.946,0.546,1.402
       c0.271,0.691,0.536,1.365,0.797,2.019c0.26,0.654,0.509,1.291,0.76,1.901c0.244,0.611,0.483,1.196,0.716,1.758
       c0.155,0.372,0.304,0.733,0.447,1.083c0.441,1.047,0.839,1.982,1.2,2.778c0.059,0.133,0.117,0.266,0.174,0.388
       c0.112,0.249,0.218,0.483,0.325,0.7c0.075,0.155,0.143,0.314,0.218,0.479c-1.807,2.315-15.094,18.43-41.222,27.274
       c-13.285,3.984-19.153,4.425-32.069,3.771C357.843,233.6,357.684,233.345,357.53,233.095 M390.094,292.621
       c-0.261-0.345-0.824-1.324-1.566-2.667c-0.017-0.016-0.033-0.025-0.043-0.047c-0.266-0.435-0.569-0.855-0.707-1.355
       c-0.012-0.031-0.006-0.059-0.006-0.09c-0.021-0.006-0.043-0.01-0.062-0.016c-3.061-5.651-7.861-15.019-8.563-16.422
       c-0.261-0.522-0.865-2.226-1.567-4.208c-1.636-4.604-4.101-11.568-5.959-14.356c-0.67-0.998-1.917-2.741-3.506-4.945
       c-2.698-3.761-6.523-9.077-9.289-13.357c2.724,0.127,5.135,0.206,7.382,0.206c8.046,0,13.943-0.988,24.247-4.079
       c24.942-8.44,38.364-23.445,41.401-27.158c4.233,10.416,9.742,35.067,10.172,38.965c0.872,7.819,2.645,15.558,4.36,23.03
       c0.187,0.824,0.373,1.653,0.564,2.481l-0.01-0.005c0.159,0.685,0.292,1.38,0.371,2.077c0.028-0.049,0.053-0.102,0.075-0.149
       c0.77,3.447,1.525,6.936,2.146,10.42c0.461,2.577,0.859,5.174,1.216,7.777c-2.449,10.681-13.598,15.201-24.209,18.218
       c-8.058,2.284-17.295,1.885-29.044-1.275C396.589,303.977,391.337,294.277,390.094,292.621 M447.718,353.755
       c-2.385,2.385-9.364,6.056-18.739,2.933c-9.178-3.06-10.718-6.619-10.91-7.187l1.237-8.12c3.48,1.131,18.501,5.475,29.978,0.169
       C449.225,346.086,448.78,352.687,447.718,353.755 M453.002,330.916c-0.371,1.571-1.078,3.016-1.763,4.418
       c-0.733,1.498-1.487,3.044-1.87,4.787c-12.285,6.139-29.94-0.016-30.35-0.161c-0.286-0.111-7.584-3.075-9.236-4.312
       c-1.51-1.132-3.097-4.536-3.303-4.988c-0.234-0.962-2.72-11.159-4.457-14.198c-1.312-2.294-3.143-7.153-3.952-9.353
       c4.818,1.258,10.932,2.528,17.422,2.528c3.734,0,7.585-0.419,11.388-1.498c10.049-2.852,20.565-7.048,24.252-16.424
       c1.104,9.025,1.694,18.135,2.267,27.025l0.006,0.143C453.656,322.683,453.932,326.996,453.002,330.916"
          />
        </g>
        <polygon
          fill="#010101"
          points="418.995,340.797 424.078,341.838 431.453,343.255 436.995,343.422 443.453,342.842 
     446.912,341.755 449.953,340.797 449.953,343.797 449.662,349.047 448.87,352.963 446.87,355.213 442.412,357.547 436.995,358.713 
     430.745,357.891 425.86,356.338 420.745,353.547 418.995,351.588 417.453,350.13 417.453,348.838 418.07,344.755 418.495,341.672 
     418.495,340.588 	"
        />
        <polygon
          fill="#010101"
          points="54.871,340.628 59.974,342.442 65.412,343.255 71.537,343.255 76.037,342.842 80.974,341.941 
     85.912,340.628 86.341,345.192 87.162,349.192 86.341,351.255 81.099,354.942 74.849,357.442 69.349,358.692 64.474,358.255 
     59.349,356.38 56.287,354.317 55.126,351.317 54.871,346.442 54.474,342.842 	"
        />
      </g>
    </svg>
  );
}
